export default __webpack_public_path__ + "static/media/check.67d4053b.svg";